export default "__VITE_ASSET__0a4b3745__"